// @flow
import { Card, Flex, Image, Typography } from '@duxton-web/ui';
import React, { useEffect, useState } from 'react';

import DataBox from 'omega-rtc/components/custom/DataBox';
import { FALL_BACK_IMAGE } from 'omega-rtc/constants/ucd';
import { getImageInfoFromUrl } from 'omega-rtc/utils/smart-campaign-utils';

const SmartCampaignImagePreview = ({ imageURL }) => {
  const [imageMetaData, setImageMetaData] = useState(null);

  useEffect(() => {
    getImageInfoFromUrl(imageURL, (imageData) => {
      setImageMetaData(imageData);
    });
  }, [imageURL]);

  return (
    <div>
      <Typography.Body level={2} strong>
        Image
      </Typography.Body>
      <Card
        style={{ marginTop: '8px' }}
        styles={{
          body: { padding: 16 },
        }}
      >
        <Flex gap={24}>
          <Image
            style={{ maxWidth: '370px' }}
            src={imageURL}
            fallback={FALL_BACK_IMAGE}
          />
          <Flex vertical gap={12} style={{ width: '370px' }}>
            <DataBox
              label={'Name'}
              content={imageMetaData && imageMetaData.name}
              width="100%"
            />
            <DataBox
              label={'Dimension'}
              content={
                imageMetaData &&
                imageMetaData.width &&
                imageMetaData.height &&
                `${imageMetaData.width} x ${imageMetaData.height}`
              }
              width="100%"
            />
            <DataBox
              label={'Size'}
              content={
                imageMetaData &&
                imageMetaData.size &&
                `${(imageMetaData.size / 1000).toFixed(1)} KB` // Convert size in bytes to kilobytes and keep the size in KB with one decimal place
              }
              width="100%"
            />
          </Flex>
        </Flex>
      </Card>
    </div>
  );
};
export default SmartCampaignImagePreview;
